import React from "react"
import {
  Paper,
  Radio,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"
import TableNoRecords from "components/TableNoRecords"
import styles from "../generateVipQuestions.module.scss"
import image from "assets/images/imagePlaceholder.png"
import AppTextField from "components/StyledComponents/AppTextField"

const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  borderRadius: "12px",
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "12px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: "none",
    boxSizing: "border-box",
    "&:first-of-type": {
      paddingLeft: 20
    }
  },
  "& .MuiTableRow-root": {
    borderBottom: `2px solid #272a2c`,
    "&:last-child": { borderBottom: "none" }
  },
  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "sticky",
    borderBottom: `2px solid #272a2c`
  }
}))

const VIPTable = ({
  columns,
  rows,
  selectedRow,
  setSelectedRow,
  editUser,
  editableRows,
  setEditableRows
}) => {
  const handleChange = (id, field, value) => {
    const updated = editableRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))

    setEditableRows(updated)
  }

  const displayedRows = editUser ? editableRows : rows

  return (
    <Paper>
      <TableContainer sx={{ maxHeight: 700 }}>
        <CustomTable stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "10px" }}></TableCell>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ width: column.minWidth }}>
                  <Typography variant="body4Regular" style={{ opacity: 0.6 }}>
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedRows?.length ? (
              displayedRows?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <Radio
                      checked={selectedRow === row.id}
                      onChange={() => setSelectedRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>
                    <img src={row?.image || image} className={styles.image} alt="VIP" />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body6Regular">{row.name}</Typography>
                  </TableCell>
                  <TableCell>
                    {editUser ? (
                      <AppTextField
                        name="work_company"
                        fullWidth
                        placeholder="Enter Company"
                        value={row.work_company}
                        onChange={(e) => handleChange(row.id, "work_company", e.target.value)}
                      />
                    ) : (
                      <Typography variant="body6Regular">{row.work_company}</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {editUser ? (
                      <AppTextField
                        name="designation"
                        fullWidth
                        placeholder="Enter Designation"
                        value={row.designation}
                        onChange={(e) => handleChange(row.id, "designation", e.target.value)}
                      />
                    ) : (
                      <Typography variant="body6Regular">{row.designation}</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {row?.profile_links?.map((link, index) => (
                      <Typography key={index} variant="body6Regular" component="span">
                        <a href={link} target="_blank" rel="noopener noreferrer">
                          <span className={styles.profile_links}>{new URL(link)?.hostname}</span>
                        </a>
                        {index < row?.profile_links?.length - 1 && ", "}
                      </Typography>
                    ))}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableNoRecords colSpan={8} label="No VIP Found" />
            )}
          </TableBody>
        </CustomTable>
      </TableContainer>
    </Paper>
  )
}

export default VIPTable
